import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetalleProductoBackview } from './detalle-producto.component.backview';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from "ngx-spinner";
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';

@NgModule({
  declarations: [DetalleProductoBackview],
  imports: [
    CommonModule,
    FormsModule,
    HeaderModule,
    FooterModule,
    NgxSpinnerModule
  ],
  exports: [
    DetalleProductoBackview
  ]
})
export class DetalleProductoModule { }
